


































































// import {
//   disableBodyScroll,
//   clearAllBodyScrollLocks,
// } from 'body-scroll-lock';
import { mapMutations, mapState } from 'vuex';
import Logo from '@/components/Logo.vue';

interface IButton {
  text: string;
  click: () => void;
}

interface IDialog {
  id: number;
  buttons?: IButton[];
  component: object;
  content?: string;
  title?: string;
}

interface IParams extends IDialog {
  compact: boolean;
  delay?: number;
}

// elements that can have focus
const focusQuerySelector = [
  'a[href]:not([tabindex^="-"]):not([inert])',
  'area[href]:not([tabindex^="-"]):not([inert])',
  'input:not([disabled]):not([inert])',
  'select:not([disabled]):not([inert])',
  'textarea:not([disabled]):not([inert])',
  'button:not([disabled]):not([inert])',
  'iframe:not([tabindex^="-"]):not([inert])',
  'audio:not([tabindex^="-"]):not([inert])',
  'video:not([tabindex^="-"]):not([inert])',
  '[contenteditable]:not([tabindex^="-"]):not([inert])',
  '[tabindex]:not([tabindex^="-"]):not([inert])',
].join(',');

export default {
  created() {
    this.$store.registerModule('dialog', {
      namespaced: true,
      state: () => ({
        dialogs: [] as IDialog[],
      }),
      mutations: {
        CLOSE_ALL: (state: any) => {
          state.dialogs = [];
        },
        CREATE: (state: any, params = {} as IParams) => {
          setTimeout(() => {
            state.dialogs = [...state.dialogs, {
              id: Math.random(),
              ...params,
            }];
          }, params.delay || 0);
        },
        REMOVE: (state: any, id: number) => {
          state.dialogs = state.dialogs.filter((dialog: IDialog) => (
            dialog.id !== id
          ));
        },
      },
    });

    this.$store.subscribe((mutation: any) => {
      const { payload, type } = mutation;
      if (type === 'dialog/CREATE') {
        // match delay to ensure dialog is available
        setTimeout(this.onShow, payload.delay || 0);
      } else if (type === 'dialog/REMOVE') {
        this.onClose();
      }
    });
  },
  mounted() {
    // remove all dialogs on route change
    this.$router.beforeEach((to: any, from: any, next: any) => {
      this.$store.commit('dialog/CLOSE_ALL');
      // clearAllBodyScrollLocks();
      next();
    });
  },
  data: () => ({
    focusElements: [] as HTMLElement[],
    triggerElements: [] as HTMLElement[],
  }),
  computed: {
    ...mapState('dialog', [
      'dialogs',
    ]),
    // first and last elements within dialog
    firstElement(): HTMLElement {
      return this.focusElements[0];
    },
    lastElement(): HTMLElement {
      return this.focusElements[this.focusElements.length - 1];
    },
    // return last element to open dialog
    triggerElement(): HTMLElement {
      return this.triggerElements[this.triggerElements.length - 1];
    },
  },
  methods: {
    ...mapMutations('dialog', [
      'CREATE',
      'REMOVE',
    ]),
    onClose() {
      setTimeout(() => {
        // focus on element which opened dialog and remove from tracked list of triggers
        // Note: timeout fixes bug where eleemnt receives last key event
        this.triggerElement && this.triggerElement.focus();
        this.triggerElements = this.triggerElements.slice(0, this.triggerElements.length - 1);
      }, 100);

      // clear scrolling locks if no dialogs exist
      // !this.dialogs.length && clearAllBodyScrollLocks();
    },
    onShow() {
      // save the element that opened it
      this.triggerElements.push(document.activeElement as HTMLElement);

      this.$nextTick(() => {
        const { wrapper } = this.$refs;
        this.focusElements = (wrapper as any).querySelectorAll(focusQuerySelector);

        // if first element is close element, select the next element
        // but if it's not close element, select it
        const [possiblyClose, firstElementInBody] = this.focusElements;
        const focusElement = possiblyClose.className.includes('_close_')
          ? firstElementInBody
          : possiblyClose;

        focusElement && focusElement.focus();

        // disableBodyScroll(wrapper);
      });
    },
    rotateFocus() {
      // focus on first element if tabbed on last element in dialog
      if (this.firstElement && document.activeElement === this.lastElement) {
        // focus on first element (tab kicks in after this)
        // then focus on element again to force first element to be in focus
        this.firstElement.focus();
        this.$nextTick(() => this.firstElement.focus());
      }
    },
  },
  components: {
    Logo,
  },
} as IView;
